/* eslint-disable react/react-in-jsx-scope */
// import chroma from 'chroma-js'
import { isEmpty, isArray } from 'lodash-es'

const makeValue = (val, defaultVal) => {
  return val ? val.title : defaultVal
}

const transformer = function (origin, defs, rowData) {
  const ret = {
    render: 'text',
    origin,
    opts: defs,
    value: origin,
    rowData,
  }

  if (isEmpty(origin)) {
    return ret
  }

  const keyedSelects = {}

  if (isEmpty(defs.selects)) {
    ret.value = origin
    return ret
  }

  defs.selects.forEach((x) => {
    keyedSelects[x.slug] = x
  })

  if (isArray(origin)) {
    ret.render = 'select'
    ret.value = origin.map((val) => {
      const option = keyedSelects[val]
      return option ? { ...option } : val
    })
  } else {
    ret.value = makeValue(keyedSelects[origin], origin)
  }

  return ret
}

export default transformer
